// extracted by mini-css-extract-plugin
export default {"h1":"heading_h1__ZP7ii","h2":"heading_h2__7rafD","h3":"heading_h3__HM3Hk","h4":"heading_h4__ysHXx","h5":"heading_h5__4bEAC","disabled":"heading_disabled__t71SM"};